import { Core } from "@faire/design-tokens";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";

interface IStockTextProps {
  limitedStockText: React.ReactNode;
  isSalesPaused: boolean;
}
export const StockTextContent: React.FC<IStockTextProps> = (props) => {
  const { limitedStockText, isSalesPaused } = props;

  if (limitedStockText) {
    return <>{limitedStockText}</>;
  } else if (isSalesPaused) {
    return (
      <Typography variant="paragraphSansRegular" color={Core.text.critical}>
        <StrictLocalMsg
          defaultMessage="Out of stock"
          description={{
            text: "This product is currently unavailable.",
          }}
        />
      </Typography>
    );
  } else {
    return null;
  }
};
